module.exports = __webpack_public_path__ + "static/media/metanet-background.8cec4b30.jpg";